import { copyToClipboard, Notify } from 'quasar';

export const copyToClipboardWithNotification = async (text: string | undefined, successMessage: string = 'Copied to clipboard',
  errorMessage: string = 'Failed to copy') => {
  if (!text) {
    Notify.create({
      message: 'Value is empty',
      color: 'warning',
      position: 'top',
    });
    return;
  }
  try {
    await copyToClipboard(text);
    Notify.create({
      message: successMessage,
      color: 'positive',
      position: 'top',
    });
  } catch (err) {
    Notify.create({
      message: errorMessage,
      color: 'negative',
      position: 'top',
    });
  }
};
